module.exports = __webpack_public_path__ + "img/gray-search.455fde1d.svg";